import React from 'react'

import Icon from '../../../Shared/Icon/Icon'

const openLoginWidget = (e) => {
  e.preventDefault()
  App.events.publish('app:login:open')
}

function LockedForGuestSection() {
  return (
    <div className="guest-lockdown">
      <Icon type={['fal', 'lock-alt']} color="grey" className="fa-5x" />
      <div className="guest-lockdown__text">
        <a href="#" onClick={openLoginWidget}>Log In</a> or
        <a href="#" onClick={openLoginWidget}> Sign up</a> to apply for this 3D Project
      </div>
    </div>
  )
}

export default LockedForGuestSection
